import React, { FC } from "react";
import { cn } from "./cn";
import { PreflightWrapper } from "@mabi-ui/preflight";

type ArrowProps = {
	className?: string;
};
export const Arrow: FC<ArrowProps> = ({ className }) => {
	return (
		<PreflightWrapper>
			<div
				className={cn(
					"overflow-hidden w-4 h-4 relative after:absolute after:w-4 after:h-4 after:bg-white after:[transform:translateY(-8px)_rotate(-60deg)_skewX(-30deg)_scale(1,_0.866)] after:rounded-bl-md",
					className
				)}
			></div>
		</PreflightWrapper>
	);
};
